import { color } from "d3-color";
import { rgb } from "d3-color";
import { formatRgb } from "culori";
export class Color {
    opacity;
    constructor() {
    }
    displayable() {
        throw new Error("Method not implemented.");
    }
    toString() {
        throw new Error("Method not implemented.");
    }
    formatHex() {
        throw new Error("Method not implemented.");
    }
    formatHex8() {
        throw new Error("Method not implemented.");
    }
    formatHsl() {
        throw new Error("Method not implemented.");
    }
    formatRgb() {
        throw new Error("Method not implemented.");
    }
    hex() {
        throw new Error("Method not implemented.");
    }
}
export const isColorInstance = (o) => {
    return o instanceof Color || o instanceof color;
};
export const isHslLike = (o) => {
    return (!!o && typeof o.h === 'number' && typeof o.s === 'number' && typeof o.l === 'number' && (typeof o.opacity === 'number' || typeof o.opacity === 'undefined'));
};
export const isCuloriLike = (o) => {
    return !!formatRgb(o);
};
export const color2bin = (color, buf, byteOffset, debug) => {
    const hexStr = color.formatHex();
    const r = Number.parseInt(`0x${hexStr.substring(1, 3)}`);
    const g = Number.parseInt(`0x${hexStr.substring(3, 5)}`);
    const b = Number.parseInt(`0x${hexStr.substring(5, 7)}`);
    const a = hexStr.length >= 9
        ? Number.parseInt(`0x${hexStr.substring(7, 9)}`)
        : Math.max(0, Math.min(255, Math.round(color.opacity * 255)));
    const colorUint8View = new Uint8Array(buf);
    colorUint8View[byteOffset + 0] = r;
    colorUint8View[byteOffset + 1] = g;
    colorUint8View[byteOffset + 2] = b;
    colorUint8View[byteOffset + 3] = a;
    if (debug) {
        console.log('color', color);
        console.log('hex', hexStr);
        console.log('r', r);
        console.log('g', g);
        console.log('b', b);
        console.log('a', a);
    }
};
export const bin2color = (buf, byteOffset, debug) => {
    const colorUint8View = new Uint8Array(buf);
    const r = colorUint8View[byteOffset + 0];
    const g = colorUint8View[byteOffset + 1];
    const b = colorUint8View[byteOffset + 2];
    const a = colorUint8View[byteOffset + 3];
    if (debug) {
        console.log('color', color);
        console.log('r', r);
        console.log('g', g);
        console.log('b', b);
        console.log('a', a);
    }
    return rgb(r, g, b, a);
};
